<template>
  <span class="sih_url_setting" style="margin-left: 4px">
    <a-button type="primary" size="small" class="sih-checkbox" @click="showImageHashConfModal">
      <a-icon type="bulb" /><span style="margin-left: 4px">
        Smart Image Hash
      </span>
    </a-button>
    <a-modal class="sih_url_setting" title="Configure Smart Image Hash" width="1200px" centered :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
      <a-alert 
        v-if="conf.policy_setting && conf.policy_setting.imgHashEnable===1"
        type="warning"
        style="margin-bottom: 16px;"
      >
        <div slot="message">
          This URL has active SIH configurations through policy setting. You can check it via this 
          <a :href="'/policy/' + conf.policy_setting.policyID + '#sih'" target="_blank">
            link</a>. 
          You can configure SIH here for this URL which will <b>override</b> policy settings.
        </div>
      </a-alert>
      <a-row>
        <a-col :span="8" style="text-align: center; height: 76px; vertical-align: middle; display: table">
          <div style="display: table-cell; vertical-align: middle">
            <a-switch :checked="is_slider_enable" @click="onCheckboxChange">
              <a-icon slot="checkedChildren" type="check" />
              <a-icon slot="unCheckedChildren" type="close" />
            </a-switch>
            <div style="font-weight: 600; font-size: 1.25em">
              Smart Image Hash
            </div>
            <div>Identify image differences smartly and reduce the number of wrong alerts of image caused by image compression and so on.</div>
          </div>
        </a-col>
        <a-col :span="1" style="height: 84px; text-align: center">
          <a-divider type="vertical" style="height: 100%" />
        </a-col>
        <a-col :span="15" style="margin-top: -6px" :class="{grayscale: !is_slider_enable}">
          <div class="slider_title">
            Alert Threshold Settings
            <a-tooltip placement="right">
              <template slot="title" style="background-color: #d9edff">
                The higher threshold, the larger the difference between images is required to 
                trigger alerts. Hence, the thresholds in 
                <span style="color: red; font-weight: 700">
                  red
                </span> may not be recommended as you may miss out on true alerts. 
                <br><b>The recommended value is 10</b>.
              </template>
              <a-icon class="explain" type="info-circle" theme="filled" />
            </a-tooltip>
          </div>
          <a-slider :min="1" :marks="slider_marks" :defaultValue="slider_default_value" :max="100" :disabled="!is_slider_enable" @afterChange="onAfterSliderChange" />
        </a-col>
      </a-row>
    </a-modal>
  </span>
</template>

<script>
import { message } from 'ant-design-vue';
export default {
  name: 'SmartImageHashConf',
  props: { conf: Object },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      is_smart_hash_enable: !!this.conf.imgHashEnable,
      is_slider_enable: !!this.conf.imgHashEnable,
      slider_default_value: this.conf.imgHashSensitivity,
      slider_marks: {
        5: {
          label: (
            <span style="color: black; font-weight: 600;">Small<br />Difference</span>
          ),
        },
        10: {
          label: (
            <a-tooltip placement="right">
              <template slot="title">Recommended alert threshold value</template>
              <a-icon type="like" style="color: green;" rotate={350} />
            </a-tooltip>
          ),
        },
        20: {
          label: <span style="color: black; font-weight: 600;">Medium</span>
        },
        48: {
          label: (
            <a-tooltip placement="right">
              <template slot="title">Not recommended</template>
              <span style="color: black; font-weight: 600;">High</span>
            </a-tooltip>
          ),
        },
        76: {
          label: (
            <a-tooltip placement="right">
              <template slot="title">Not recommended</template>
              <span style="color: black; font-weight: 600;">Very High</span>
            </a-tooltip>
          ),
        },
        95: {
          style: {
            width: "100px"
          },
          label: (
            <a-tooltip placement="right">
              <template slot="title">Not recommended</template>
              <span style="color: black; font-weight: 600;">Extremely High<br/>Difference</span>
            </a-tooltip>
          ),
        },
      },
      changed_conf: {
        sih_threshold: this.conf.imgHashSensitivity,
        enable_sih: !!this.conf.imgHashEnable,
      },
      temp_changed_conf: {
        sih_threshold: this.conf.imgHashSensitivity,
        enable_sih: !!this.conf.imgHashEnable,
      },
    };
  },
  methods: {
    showImageHashConfModal() {
      this.visible = true;
    },
    handleOk(e) {
      message.info('Please remember to save the configuration.');
      this.confirmLoading = true;
      this.changed_conf['sih_threshold'] = this.temp_changed_conf['sih_threshold'];
      this.changed_conf['enable_sih'] = this.temp_changed_conf['enable_sih'];
      this.$emit('onChangeSmartImageHashConf', this.changed_conf);
      this.visible = false;
      this.confirmLoading = false;
    },
    handleCancel(e) {
      this.is_slider_enable = !!this.changed_conf['enable_sih'];
      this.slider_default_value = this.changed_conf['sih_threshold'];
      this.visible = false;
    },
    onCheckboxChange(e) {
      this.is_slider_enable = !this.is_slider_enable;
      this.temp_changed_conf['enable_sih'] = this.is_slider_enable;
    },
    onAfterSliderChange(value) {
      this.temp_changed_conf['sih_threshold'] = value;
    },
  },
};
</script>

<style scoped>
.sih-checkbox {
  font-size: 0.8em !important;
}

.slider_title {
  font-weight: 600;
  font-size: 1.25em;
}

.ant-divider.ant-divider-vertical {
  /* Separator vertial line in the modal */
  width: 2px;
  background-color: rgb(211, 211, 211);
}

.grayscale {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.4;
}
</style>

<style>
.sih_url_setting .ant-modal-body {
  padding-top: 16px;
}
</style>
